// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.formValidations_dashboard__4bIJP {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 35px 35px;
  border-radius: 0px;
  min-height: auto !important;
  background-color: #f5f6fa;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.formValidations_dashboardContain__vIanX {
  width: calc(100% - 320px);
  background-color: #f5f6fa;
  border-radius: 8px;
}

.formValidations_bodythemedark__62q0X .formValidations_dashboardContain__vIanX,
.formValidations_bodythemedark__62q0X .formValidations_dashboard__4bIJP,
.formValidations_bodythemedark__62q0X .formValidations_cont2__WwCeX {
  background-color: #0f1824;
}

.formValidations_top_header__7NlB- .formValidations_top_header_inner__W3YY1 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.formValidations_cont2__WwCeX {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #f5f6fa;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.formValidations_subLink__aL7p8 svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.formValidations_footer__oEjbs {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.formValidations_bodythemelight__\\+-XVE {
  background-color: #fff;
  padding-top: 90px;
}

.formValidations_bodythemedark__62q0X {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.formValidations_headerthemelight__5B5jM {
  background-color: #fff;
}

.formValidations_headerthemedark__357jy {
  background-color: #132337;
}

.formValidations_top_header__7NlB- {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.formValidations_menuthemelight__aEAoa {
  background-color: #fff;
}

.formValidations_menuthemedark__QV\\+cZ {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.formValidations_menulinklight__h1aH6 span {
  color: #666666 !important;
}

.formValidations_menulinklight__h1aH6 a {
  color: #cbcbcb !important;
}

.formValidations_menulinklight__h1aH6:hover span,
.formValidations_menulinklight__h1aH6:hover a {
  color: #fff !important;
}

.formValidations_menulinkdarkSelected__btAJt {
  background-color: #1c2e45;
  color: #3b82f6;
}

.formValidations_menuthemelight__aEAoa .formValidations_menulinklightSelected__pC9ID {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #0f4d0f;
}

.formValidations_menuthemelight__aEAoa .formValidations_menulinklightSelected__pC9ID svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.formValidations_menulinkdark__chaDb {
  color: #92afd3 !important;
}

.formValidations_menulinklight__h1aH6:hover {
  color: #fff !important;
  background-color: #0f4d0f;
}

.formValidations_menulinklight__h1aH6:hover svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.formValidations_menulinklight__h1aH6 .formValidations_sub_arrow__Hqpjq svg path {
  stroke: #cbcbcb !important;
}

.formValidations_menulinklight__h1aH6:hover .formValidations_sub_arrow__Hqpjq svg path {
  stroke: #fff !important;
}

.formValidations_menulinkdark__chaDb .formValidations_sub_arrow__Hqpjq svg path {
  stroke: #92afd3 !important;
}

.formValidations_menulinkdark__chaDb:hover .formValidations_sub_arrow__Hqpjq svg path {
  stroke: #fff !important;
}

.formValidations_menulinkdark__chaDb:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.formValidations_headinglight__fJ0qi {
  color: #60677e;
}

.formValidations_headingdark__rv4Qd {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.formValidations_searchboxlight__9QD4Z {
  background-color: #fff;
  border: none;
}

.formValidations_searchboxdark__L4vtf {
  background-color: #132337;
  color: #fff;
  border: none;
}

.formValidations_searchboxdark__L4vtf::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.formValidations_tableheadlight__4Xu-Z {
  background-color: #131f43;
  border-radius: 5px 5px 0px 0px;
}

.formValidations_tableheadlight__4Xu-Z th {
  color: #fff;
  background-color: #0f4d0f;
}

thead .formValidations_tableheadlight__4Xu-Z th:first-child,
thead .formValidations_tableheaddark__5Xe-M th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .formValidations_tableheadlight__4Xu-Z th:last-child,
thead .formValidations_tableheaddark__5Xe-M th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.formValidations_table__0ZGXg.formValidations_table-borderless__k6lTp {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.formValidations_tableheaddark__5Xe-M {
  background-color: #132337;
  color: #fff;
}

.formValidations_table-borderless__k6lTp tr:nth-child(even) {
  background-color: #f9fafb;
}

.formValidations_table-borderless__k6lTp .formValidations_left-section__eO-Zm {
  padding-top: 10px;
}

.formValidations_tablebodylight__7Maem td,
.formValidations_tablebodydark__F4Rtf td {
  padding: 0.5rem 1rem !important;
  line-height: 30px;
}

.formValidations_tablebodylight__7Maem {
  background-color: #fff;
}
.formValidations_tablebodylight__7Maem:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.formValidations_tablebodydark__F4Rtf {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.formValidations_tablebodydark__F4Rtf:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.formValidations_paginationlight__m\\+Lw8 {
  color: #60677e !important;
  font-size: 13px !important;
}

.formValidations_paginationdark__UEbsC {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.formValidations_formthemelight__e5vWq {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.formValidations_formthemedark__TABaF {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.formValidations_formthemedark__TABaF ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.formValidations_viewformlight__1Fyp6 {
  background-color: #f3f6f9;
}

.formValidations_permissionboxlight__fS1Dx {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.formValidations_permissionboxdark__6mhFX {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.formValidations_errormsgclr__Auf2Q {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.formValidations_graphclrlight__U1q4P {
  background-color: #fff;
}

.formValidations_graphclrdark__IwnuE {
  background-color: #132337;
}

/* 
Counter theme
*/
#formValidations_card1bglight__G2OBy {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#formValidations_card1bgdark__SQt-5 {
  background: #392f28;
}

#formValidations_card2bglight__N5sZT {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#formValidations_card2bgdark__6cfhD {
  background: #1c3238;
}

#formValidations_card3bglight__NC4mA {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#formValidations_card3bgdark__M3d\\+7 {
  background: #3a2434;
}

#formValidations_card4bglight__FWWoE {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#formValidations_card4bgdark__i3DVG {
  background: #2f264f;
}

#formValidations_card1bgdark__SQt-5 a,
#formValidations_card1bgdark__SQt-5 p,
#formValidations_card2bgdark__6cfhD a,
#formValidations_card2bgdark__6cfhD p,
#formValidations_card3bgdark__M3d\\+7 a,
#formValidations_card3bgdark__M3d\\+7 p,
#formValidations_card4bgdark__i3DVG a,
#formValidations_card4bgdark__i3DVG p {
  color: #fff;
}

/* 
Action button theme
*/
.formValidations_actionbtnlight__qtAFh {
  color: rgba(70, 71, 91, 0.8705882353);
}

.formValidations_actionbtnlight__qtAFh:hover {
  cursor: pointer;
}

.formValidations_actionbtndark__M0g2d {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.formValidations_profiledropdownlight__Jy2y3 {
  background-color: #fff;
}

.formValidations_profiledropdowndark__Fit-9 {
  background-color: #151521;
}

.formValidations_settingsection__JKqt- #formValidations_addform__bbMsV.formValidations_formthemedark__TABaF .formValidations_savebtn__9EKoG {
  background-color: #3b82f6;
  color: #fff;
}

#formValidations_addform__bbMsV.formValidations_formthemedark__TABaF .formValidations_savebtn__9EKoG {
  background-color: #3b82f6;
  color: #fff;
}

.formValidations_profile_conatiner__n4ENC {
  border-radius: 5px !important;
}

.formValidations_bodythemedark__62q0X .formValidations_ag-theme-alpine__gw-Ew .formValidations_ag-row__C6SuU {
  background: #000 !important;
}

.formValidations_bodythemedark__62q0X .formValidations_formbtn__zluzT {
  background-color: #3b82f6;
}

.formValidations_bodythemedark__62q0X .formValidations_formbtn__zluzT:hover {
  background-color: #2563eb;
}

.formValidations_bodythemedark__62q0X .formValidations_resetbtn__iLteT {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.formValidations_bodythemedark__62q0X .formValidations_resetbtn__iLteT:hover {
  background-color: #3b82f6;
}

.formValidations_headingdark__rv4Qd span {
  background-color: #132337;
}

.formValidations_resetbtn__iLteT {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131f43;
  color: #131f43;
  min-width: 113px;
}

.formValidations_resetbtn__iLteT:hover,
.formValidations_resetbtn__iLteT:active,
.formValidations_resetbtn__iLteT:focus {
  background-color: #131f43;
  color: #fff;
}

.formValidations_addBtn__u24yu {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38a169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.formValidations_addbtnlight__AqRpQ {
  background-color: #38a169;
}

.formValidations_addbtndark__qKX5I {
  background-color: #3b82f6;
}

.formValidations_addbtndark__qKX5I:hover {
  background-color: #2563eb;
}

.formValidations_formthemedark__TABaF label {
  color: #92afd3;
}

.formValidations_addBtn__u24yu svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.formValidations_addBtn__u24yu:hover {
  color: #fff;
  background-color: #38a169;
  border: none;
}

.formValidations_cust_addBtn__qwmrZ.formValidations_addBtn__u24yu svg {
  top: 2px;
}

.formValidations_deleteBtn__8lymR {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.formValidations_deleteBtn__8lymR {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.formValidations_deleteBtn__8lymR:active,
.formValidations_deleteBtn__8lymR:focus {
  background-color: #f94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.formValidations_deleteBtn__8lymR svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.formValidations_deleteBtn__8lymR:hover,
.formValidations_deleteBtn__8lymR:active,
.formValidations_deleteBtn__8lymR:focus {
  background-color: #f94747;
  color: #fff;
  border: none;
}

.formValidations_confirmBtn__oIzTe {
  background-color: #131f43;
}

.formValidations_confirmBtn__oIzTe:hover,
.formValidations_confirmBtn__oIzTe:active,
.formValidations_confirmBtn__oIzTe:focus {
  background-color: #131f43;
}

.formValidations_confirmBtn__oIzTe svg {
  top: 0;
}

.formValidations_delPopContainer__eb7aO .formValidations_modal-body__sWpIj {
  padding: 25px;
  text-align: center;
}

.formValidations_delPopContainer__eb7aO .formValidations_delet_icon__xrmCk {
  margin-bottom: 11px;
}

.formValidations_delPopContainer__eb7aO p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.formValidations_arrowback__E00hC svg {
  fill: #000;
}

.formValidations_bodythemedark__62q0X .formValidations_arrowback__E00hC {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.formValidations_bodythemedark__62q0X .formValidations_arrowback__E00hC svg {
  fill: #3b82f6;
}

.formValidations_bodythemedark__62q0X .formValidations_drpdwn_btn__1vAaY {
  background-color: #132337;
}

.formValidations_bodythemedark__62q0X .formValidations_empname__pwHcv {
  color: #92afd3 !important;
}

.formValidations_bodythemedark__62q0X .formValidations_navitemli__20b6W a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.formValidations_bodythemedark__62q0X .formValidations_tabnavli__r8CwV a.formValidations_settingsgeneral__k5xiy,
.formValidations_bodythemedark__62q0X .formValidations_tabnavli__r8CwV a.formValidations_settingslinks__pCKrW:hover {
  background-color: #3b82f6;
  color: #fff;
}

.formValidations_bodythemedark__62q0X .formValidations_tabnavli__r8CwV a.formValidations_settingslinks__pCKrW {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.formValidations_headerthemedark__357jy .formValidations_dropdown_menu_contain__Jgstj {
  background-color: #1c2e45;
  color: #fff;
}

.formValidations_headerthemedark__357jy .formValidations_dropdown_menu_contain__Jgstj ul li a,
.formValidations_headerthemedark__357jy .formValidations_dropdown_menu_contain__Jgstj .formValidations_dropdown_item__uWKE2,
.formValidations_headerthemedark__357jy .formValidations_dropdown_menu_contain__Jgstj .formValidations_dropdown_item__uWKE2 h5 {
  color: #fff;
}

.formValidations_headerthemedark__357jy .formValidations_dropdown_menu_contain__Jgstj ul li a:hover,
.formValidations_headerthemedark__357jy .formValidations_dropdown_menu_contain__Jgstj .formValidations_dropdown_item__uWKE2:hover {
  background-color: #132337;
  color: #fff;
}

.formValidations_dropdown_item__uWKE2:active {
  background-color: #f5f6fa;
}

.formValidations_profile_arrrow_dwn__hQlWp {
  stroke: #132337;
}

.formValidations_headerthemedark__357jy .formValidations_profile_arrrow_dwn__hQlWp {
  stroke: #fff;
}

.formValidations_dateinputbox1__0B2A- input,
.formValidations_dateinputbox1__0B2A- span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .formValidations_tableheadlight__4Xu-Z th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .formValidations_dashboard__4bIJP {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .formValidations_cont2__WwCeX {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (min-width: 767px) {
  .formValidations_messageminwidth__C\\+uHx {
    white-space: normal;
    word-wrap: break-word;
    width: 37%;
  }
}
@media only screen and (max-width: 767px) {
  td {
    max-width: 700px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .formValidations_messageminwidth__C\\+uHx {
    white-space: nowrap;
    word-wrap: break-word;
  }
  .formValidations_sectionright__kETD4 {
    float: unset !important;
  }
  .formValidations_dashboard__4bIJP {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .formValidations_cont2__WwCeX {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
    overflow-x: inherit !important;
  }
  .formValidations_bodythemelight__\\+-XVE,
  .formValidations_bodythemedark__62q0X {
    padding-top: 83px;
  }
  .formValidations_top_header__7NlB- {
    min-height: 69px;
  }
}
@media (min-width: 576px) {
  .formValidations_exer_modal_contain__n48g5 .formValidations_modal-dialog__SSaw5 {
    max-width: 1055px;
  }
  .formValidations_delPopContainer__eb7aO .formValidations_modal-dialog__SSaw5 {
    max-width: 350px;
  }
}
#formValidations_addform__bbMsV {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  padding-bottom: 30px;
}
#formValidations_addform__bbMsV #formValidations_addheading__z7Ps1 {
  font-size: 18px;
  margin-bottom: 20px;
}
#formValidations_addform__bbMsV .formValidations_inputbox1__OWmRi {
  padding: 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #0f1824;
  color: #fff;
}
#formValidations_addform__bbMsV .formValidations_inputbox1__OWmRi:-webkit-autofill,
#formValidations_addform__bbMsV .formValidations_inputbox1__OWmRi:-webkit-autofill:focus {
  -webkit-transition: background-color 0s 600000s, color 0s 600000s !important;
  transition: background-color 0s 600000s, color 0s 600000s !important;
}
#formValidations_addform__bbMsV input:-webkit-autofill,
#formValidations_addform__bbMsV input:-webkit-autofill:focus {
  background-color: #0f1824 !important;
}
#formValidations_addform__bbMsV .formValidations_dateinputbox__okDOR {
  background-color: #f5f6fa;
  border-radius: 5px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
#formValidations_addform__bbMsV .formValidations_dateinputbox1__0B2A- {
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #0f1824;
  color: #60677e;
}
#formValidations_addform__bbMsV .formValidations_formbtn__zluzT {
  background-color: #131f43;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
  margin-right: 10px;
}
#formValidations_addform__bbMsV .formValidations_formbtn__zluzT:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#formValidations_addform__bbMsV .formValidations_resetbtn__iLteT {
  margin-left: 10px;
  background-color: rgba(180, 184, 192, 0.3882352941);
  color: #212529;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#formValidations_addform__bbMsV .formValidations_resetbtn__iLteT:hover {
  background-color: rgba(37, 105, 109, 0.864);
  color: #fff;
}
#formValidations_addform__bbMsV ::placeholder {
  font-size: 14px;
  color: #60677e;
}
#formValidations_addform__bbMsV .formValidations_labeltext__6vPe7 {
  color: #1d1d1d;
  font-size: 14px;
  font-weight: 500;
}
#formValidations_addform__bbMsV .formValidations_eyeicon__ugyzc {
  margin-left: -30px;
  cursor: pointer;
}
#formValidations_addform__bbMsV .formValidations_arrowback__E00hC {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#formValidations_addform__bbMsV .formValidations_arrowback__E00hC:hover {
  background-color: #39979d;
  color: #fff;
}

@media only screen and (max-width: 600px) {
  #formValidations_dashboardcont2__zoJAt {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/Validations/formValidations.module.scss"],"names":[],"mappings":"AAEA;EACE,mCAAA;ACAF;;ADGA;;EAAA;AAgDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AAQA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAvFO;EAwFP,2BAAA;EACA,gBAAA;ACrEF;;ADuEA;EACE,yBAAA;EACA,yBA7FO;EA8FP,kBAAA;ACpEF;;ADsEA;;;EAGE,yBAjEmB;ACFrB;;ADqEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;AClEF;;ADqEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBArHO;EAsHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;AChEF;;ADsEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACnEF;;ADsEA;EACE,YAAA;ACnEF;;ADsEA;EACE,sBA9FY;AC2Bd;;ADsEA;;CAAA;AAGA;EACE,sBArGY;EAsGZ,iBAAA;ACnEF;;ADqEA;EACE,yBApHe;EAqHf,iBAAA;AClEF;;ADqEA;;CAAA;AAGA;EACE,sBAjHY;AC+Cd;;ADqEA;EACE,yBAhIe;AC8DjB;;ADoEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACjEF;;ADoEA;;CAAA;AAGA;EACE,sBArIY;ACoEd;;ADmEA;EACE,yBAnJe;ACmFjB;;ADmEA;;CAAA;AAGA;EACE,yBAAA;AChEF;;ADmEA;EACE,yBAAA;AChEF;;ADmEA;;EAEE,sBAAA;AChEF;;ADmEA;EACE,yBArKqB;EAsKrB,cA9KiB;AC8GnB;;ADkEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAAA;AC/DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,yBAnNqB;EAoNrB,WA3MY;AC6Id;;ADiEA;;CAAA;AAGA;EACE,cA/Me;ACiJjB;;ADiEA;EACE,cAnNe;ACqJjB;;ADiEA;;CAAA;AAGA;EACE,sBA7NY;EA8NZ,YAAA;AC9DF;;ADiEA;EACE,yBA7Oe;EA8Of,WAnOY;EAoOZ,YAAA;AC9DF;;ADgEA;EACE,cApOe;ACuKjB;;ADgEA;;CAAA;AAGA;EACE,yBAzRc;EA0Rd,8BAAA;AC7DF;;AD+DA;EACE,WAlPY;EAmPZ,yBAAA;AC5DF;;AD8DA;;EAEE,0BAAA;AC3DF;;AD6DA;;EAEE,0BAAA;AC1DF;;AD4DA;EACE,kBAAA;ACzDF;;AD2DA;EACE,kBAAA;ACxDF;;AD0DA;EACE,oCAAA;EACA,gCAAA;ACvDF;;AD0DA;EACE,yBAjQkB;EAkQlB,WA1QY;ACmNd;;ADyDA;EACE,yBAAA;ACtDF;;ADwDA;EACE,iBAAA;ACrDF;;ADuDA;;EAEE,+BAAA;EACA,iBAAA;ACpDF;;ADsDA;EACE,sBAxRY;ACqOd;ADqDE;EACE,yBAAA;EACA,YAAA;ACnDJ;;ADsDA;EACE,0CAAA;EACA,cA9Re;AC2OjB;ADqDE;EACE,yCAAA;EACA,YAAA;ACnDJ;;ADuDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;ACpDF;;ADsDA;EACE,yBAAA;EACA,0BAAA;ACnDF;;ADsDA;;CAAA;AAGA;EACE,sBAzTY;EA0TZ,yBAAA;EACA,qDAAA;ACnDF;;ADqDA;EACE,yBAtTkB;EAuTlB,yBAAA;EACA,eAAA;AClDF;ADoDE;EACE,cAhUa;AC8QjB;;ADsDA;;CAAA;AAGA;EACE,yBA9UgB;AC2RlB;;ADsDA;EACE,yBAAA;EACA,yBAAA;ACnDF;;ADqDA;EACE,yBA7VmB;EA8VnB,yBAAA;AClDF;;ADqDA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AClDF;;ADqDA;;CAAA;AAGA;EACE,sBAjWY;AC+Sd;;ADqDA;EACE,yBA7VkB;AC2SpB;;ADqDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA7WY;AC2Td;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAtXY;ACoUd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBA/XY;AC6Ud;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAxYY;ACsVd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;;;;;;;;EAQE,WAvZY;ACqWd;;ADqDA;;CAAA;AAGA;EACE,qCAAA;AClDF;;ADoDA;EACE,eAAA;ACjDF;;ADmDA;EACE,cAjae;ACiXjB;;ADmDA;;CAAA;AAGA;EACE,sBAAA;AChDF;;ADmDA;EACE,yBAAA;AChDF;;ADmDA;EACE,yBAlciB;EAmcjB,WApbY;ACoYd;;ADkDA;EACE,yBAtciB;EAucjB,WAxbY;ACyYd;;ADkDA;EACE,6BAAA;AC/CF;;ADkDA;EACE,2BAAA;AC/CF;;ADkDA;EACE,yBAndiB;ACoanB;;ADkDA;EACE,yBAtduB;ACuazB;;ADkDA;EACE,WA5cY;EA6cZ,6BAAA;EACA,yBAAA;AC/CF;;ADkDA;EACE,yBAjeiB;ACkbnB;;ADkDA;EACE,yBAjee;ACkbjB;;ADkDA;EACE,eAAA;EACA,gBA5gBc;EA6gBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA1gBc;EA2gBd,gBAAA;AC/CF;;ADiDA;;;EAGE,yBAhhBc;EAihBd,WAteY;ACwbd;;ADiDA;EACE,gBAAA;EACA,YAAA;EACA,WA5eY;EA6eZ,yBAtgBY;EAugBZ,YAAA;EACA,eAAA;EACA,gBAjiBc;ACmfhB;;ADiDA;EACE,yBA7gBY;AC+dd;;ADgDA;EACE,yBAtgBiB;ACydnB;;AD+CA;EACE,yBAxgBuB;AC4dzB;;AD+CA;EACE,cA9gBgB;ACkelB;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;AC5CF;;AD+CA;EACE,WAxgBY;EAygBZ,yBAliBY;EAmiBZ,YAAA;AC5CF;;AD+CA;EACE,QAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAtiBU;EAuiBV,WArhBY;EAshBZ,eAAA;EACA,gBAxkBc;EAykBd,YAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAhjBU;EAijBV,WA/hBY;EAgiBZ,eAAA;EACA,gBAllBc;EAmlBd,YAAA;AC5CF;;AD+CA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;AC5CF;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;AC5CF;;AD+CA;;;EAGE,yBAvkBU;EAwkBV,WAtjBY;EAujBZ,YAAA;AC5CF;;AD+CA;EACE,yBAtmBc;AC0jBhB;;AD+CA;;;EAGE,yBA5mBc;ACgkBhB;;AD+CA;EACE,MAAA;AC5CF;;AD+CA;EACE,aAAA;EACA,kBAAA;AC5CF;;AD+CA;EACE,mBAAA;AC5CF;;AD+CA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC5CF;;AD+CA;EACE,UAAA;AC5CF;;AD+CA;EACE,yCAzmBa;EA0mBb,cA9mBiB;ACkkBnB;;AD+CA;EACE,aAlnBiB;ACskBnB;;AD+CA;EACE,yBAhnBe;ACokBjB;;AD+CA;EACE,yBAAA;AC5CF;;AD+CA;EACE,6BAAA;EACA,yBAAA;EACA,WA/mBY;ACmkBd;;AD+CA;;EAEE,yBAnoBiB;EAooBjB,WArnBY;ACykBd;;AD8CA;EACE,6BAAA;EACA,yBAAA;EACA,WA1nBY;AC+kBd;;AD8CA;EACE,yBAvoBqB;EAwoBrB,WA/nBY;AColBd;;AD8CA;;;EAGE,WAroBY;AC0lBd;;AD8CA;;EAEE,yBArpBe;EAspBf,WA3oBY;ACgmBd;;AD8CA;EACE,yBA3rBO;ACgpBT;;AD8CA;EACE,eA9pBe;ACmnBjB;;AD8CA;EACE,YAvpBY;AC4mBd;;AD8CA;;EAEE,sBAAA;AC3CF;;AD8CA,iBAAA;AAOA;EACE;IACE,gBAAA;ECjDF;AACF;ADmDA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECjDF;EDmDA;IACE,2BAAA;IACA,gBAAA;ECjDF;AACF;ADmDA;EACE;;IAAA;AC/CF;ADmDA;EACE;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;ECjDF;AACF;ADoDA;EACE;IACE,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EClDF;EDoDA;IACE,mBAAA;IACA,qBAAA;EClDF;EDoDA;IACE,uBAAA;EClDF;EDoDA;IACE,6BAAA;EClDF;AACF;ADoDA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;IACA,8BAAA;ECnDF;EDqDA;;IAEE,iBAAA;ECnDF;EDqDA;IACE,gBAAA;ECnDF;AACF;ADsDA;EACE;IACE,iBAAA;ECpDF;EDsDA;IACE,gBAAA;ECpDF;AACF;AAnvBA;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAovBJ;AAlvBI;EACI,eAAA;EACA,mBAAA;AAovBR;AAjvBI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBD+Ba;EC9Bb,WDwCM;AC2sBd;AAhvBI;;EAEI,4EAAA;EAAA,oEAAA;AAkvBR;AA/uBI;;EAEE,oCAAA;AAivBN;AA/uBI;EACI,yBDjBC;ECkBD,kBAAA;EACA,WAAA;EACA,cDyBM;ECxBN,eAAA;AAivBR;AA/uBI;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDOa;ECNb,cDmBS;AC8tBjB;AA9uBI;EACI,yBDyBW;ECxBX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAgvBR;AA9uBQ;EACI,2CDgBS;ACguBrB;AA7uBI;EACI,iBAAA;EACA,mDAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA+uBR;AA7uBI;EACI,2CAAA;EACA,WAAA;AA+uBR;AA5uBI;EACI,eAAA;EACA,cDfS;AC6vBjB;AA5uBI;EACI,cDpBM;ECqBN,eAAA;EACA,gBAAA;AA8uBR;AA5uBM;EACE,kBAAA;EACA,eAAA;AA8uBR;AA3uBM;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA6uBR;AA3uBU;EACE,yBAAA;EACA,WAAA;AA6uBZ;;AAzuBE;EACE;IACI,wBDjBI;ICkBJ,UDjBG;ICkBH,kBAAA;IACA,aDzBW;ECqwBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: 'Urbanist', sans-serif;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #f5f6fa;\n$primary-color: #131f43;\n$icon-bgcolor: #f6f6f6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #f3f4f8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #faf4fb;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #faf7f3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #f5f9fc;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #ac44bb;\n$cardIcon3-color: #d69a5f;\n$cardIcon4-color: #176ca5;\n$green-color: #38a169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading: #0b0d0f;\n$light-gray: #999999;\n$menu_icon: #cbcbcb;\n$red-color: #f94747;\n$dark-active-blue: #3b82f6;\n$dark-light-blue: #92afd3;\n$addBtn-dark-blue: #3b82f6;\n$addBtn-dark-blue-hover: #2563eb;\n$backBtn-dark: #3b82f633;\n\n$darkTheme_blue: #132337;\n$darkTheme_darkBlue: #0f1824;\n$darkTheme_selectBlue: #1c2e45;\n$darkTheme_updateBtn: #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131f43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: 35px 35px;\n  border-radius: 0px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-color: $mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n.menuthemelight .menulinklightSelected svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n\n.menulinklight:hover svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n  background-color: #0f4d0f;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n}\ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #f9fafb;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 30px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover {\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color: $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n}\n\n.modalStyleDark {\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (min-width: 767px) {\n  .messageminwidth {\n    white-space: normal;\n    word-wrap: break-word;\n    width: 37%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  td {\n    max-width: 700px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .messageminwidth {\n    white-space: nowrap;\n    word-wrap: break-word;\n  }\n  .sectionright {\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n \n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n    overflow-x: inherit !important;\n  }\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 83px;\n  }\n  .top_header {\n    min-height: 69px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n}\n","@import \"../../styles/Variables/Variables.scss\";\n\n#addform{\n\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 30px;\n    padding-bottom:30px;\n\n    #addheading{\n        font-size: 18px;\n        margin-bottom: 20px;\n    }\n\n    .inputbox1{\n        padding: 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkTheme_darkBlue;\n        color: $white-color;\n         \n    }\n    .inputbox1:-webkit-autofill,\n    .inputbox1:-webkit-autofill:focus{\n        transition: background-color 0s 600000s, color 0s 600000s !important;\n         \n    }\n    input:-webkit-autofill,\n    input:-webkit-autofill:focus {\n      background-color: $darkTheme_darkBlue !important;\n    }\n    .dateinputbox{\n        background-color: $mainBg;\n        border-radius: 5px;\n        width: 100%;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .dateinputbox1{\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkTheme_darkBlue;\n        color: $lightthemetext;\n    }\n\n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n        margin-right: 10px;\n\n        &:hover{\n            background-color: $secondary-btncolor;\n        }\n    }\n    .resetbtn{\n        margin-left: 10px;\n        background-color: #b4b8c063;\n        color: #212529;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n    }\n    .resetbtn:hover{\n        background-color: rgba(37, 105, 109, 0.864);\n        color:#fff;\n    }\n    \n    ::placeholder{\n        font-size: 14px;\n        color: $lightthemetext;\n    }\n    .labeltext{\n        color: $black-color;\n        font-size: 14px;\n        font-weight: 500;\n     }\n      .eyeicon{\n        margin-left: -30px;\n        cursor: pointer;\n      }\n\n      .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #39979d;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #39979d;\n            color: #fff;\n          }\n      }\n  }\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `formValidations_dashboard__4bIJP`,
	"dashboardContain": `formValidations_dashboardContain__vIanX`,
	"bodythemedark": `formValidations_bodythemedark__62q0X`,
	"cont2": `formValidations_cont2__WwCeX`,
	"top_header": `formValidations_top_header__7NlB-`,
	"top_header_inner": `formValidations_top_header_inner__W3YY1`,
	"subLink": `formValidations_subLink__aL7p8`,
	"footer": `formValidations_footer__oEjbs`,
	"bodythemelight": `formValidations_bodythemelight__+-XVE`,
	"headerthemelight": `formValidations_headerthemelight__5B5jM`,
	"headerthemedark": `formValidations_headerthemedark__357jy`,
	"menuthemelight": `formValidations_menuthemelight__aEAoa`,
	"menuthemedark": `formValidations_menuthemedark__QV+cZ`,
	"menulinklight": `formValidations_menulinklight__h1aH6`,
	"menulinkdarkSelected": `formValidations_menulinkdarkSelected__btAJt`,
	"menulinklightSelected": `formValidations_menulinklightSelected__pC9ID`,
	"menulinkdark": `formValidations_menulinkdark__chaDb`,
	"sub_arrow": `formValidations_sub_arrow__Hqpjq`,
	"headinglight": `formValidations_headinglight__fJ0qi`,
	"headingdark": `formValidations_headingdark__rv4Qd`,
	"searchboxlight": `formValidations_searchboxlight__9QD4Z`,
	"searchboxdark": `formValidations_searchboxdark__L4vtf`,
	"tableheadlight": `formValidations_tableheadlight__4Xu-Z`,
	"tableheaddark": `formValidations_tableheaddark__5Xe-M`,
	"table": `formValidations_table__0ZGXg`,
	"table-borderless": `formValidations_table-borderless__k6lTp`,
	"left-section": `formValidations_left-section__eO-Zm`,
	"tablebodylight": `formValidations_tablebodylight__7Maem`,
	"tablebodydark": `formValidations_tablebodydark__F4Rtf`,
	"paginationlight": `formValidations_paginationlight__m+Lw8`,
	"paginationdark": `formValidations_paginationdark__UEbsC`,
	"formthemelight": `formValidations_formthemelight__e5vWq`,
	"formthemedark": `formValidations_formthemedark__TABaF`,
	"viewformlight": `formValidations_viewformlight__1Fyp6`,
	"permissionboxlight": `formValidations_permissionboxlight__fS1Dx`,
	"permissionboxdark": `formValidations_permissionboxdark__6mhFX`,
	"errormsgclr": `formValidations_errormsgclr__Auf2Q`,
	"graphclrlight": `formValidations_graphclrlight__U1q4P`,
	"graphclrdark": `formValidations_graphclrdark__IwnuE`,
	"card1bglight": `formValidations_card1bglight__G2OBy`,
	"card1bgdark": `formValidations_card1bgdark__SQt-5`,
	"card2bglight": `formValidations_card2bglight__N5sZT`,
	"card2bgdark": `formValidations_card2bgdark__6cfhD`,
	"card3bglight": `formValidations_card3bglight__NC4mA`,
	"card3bgdark": `formValidations_card3bgdark__M3d+7`,
	"card4bglight": `formValidations_card4bglight__FWWoE`,
	"card4bgdark": `formValidations_card4bgdark__i3DVG`,
	"actionbtnlight": `formValidations_actionbtnlight__qtAFh`,
	"actionbtndark": `formValidations_actionbtndark__M0g2d`,
	"profiledropdownlight": `formValidations_profiledropdownlight__Jy2y3`,
	"profiledropdowndark": `formValidations_profiledropdowndark__Fit-9`,
	"settingsection": `formValidations_settingsection__JKqt-`,
	"addform": `formValidations_addform__bbMsV`,
	"savebtn": `formValidations_savebtn__9EKoG`,
	"profile_conatiner": `formValidations_profile_conatiner__n4ENC`,
	"ag-theme-alpine": `formValidations_ag-theme-alpine__gw-Ew`,
	"ag-row": `formValidations_ag-row__C6SuU`,
	"formbtn": `formValidations_formbtn__zluzT`,
	"resetbtn": `formValidations_resetbtn__iLteT`,
	"addBtn": `formValidations_addBtn__u24yu`,
	"addbtnlight": `formValidations_addbtnlight__AqRpQ`,
	"addbtndark": `formValidations_addbtndark__qKX5I`,
	"cust_addBtn": `formValidations_cust_addBtn__qwmrZ`,
	"deleteBtn": `formValidations_deleteBtn__8lymR`,
	"confirmBtn": `formValidations_confirmBtn__oIzTe`,
	"delPopContainer": `formValidations_delPopContainer__eb7aO`,
	"modal-body": `formValidations_modal-body__sWpIj`,
	"delet_icon": `formValidations_delet_icon__xrmCk`,
	"arrowback": `formValidations_arrowback__E00hC`,
	"drpdwn_btn": `formValidations_drpdwn_btn__1vAaY`,
	"empname": `formValidations_empname__pwHcv`,
	"navitemli": `formValidations_navitemli__20b6W`,
	"tabnavli": `formValidations_tabnavli__r8CwV`,
	"settingsgeneral": `formValidations_settingsgeneral__k5xiy`,
	"settingslinks": `formValidations_settingslinks__pCKrW`,
	"dropdown_menu_contain": `formValidations_dropdown_menu_contain__Jgstj`,
	"dropdown_item": `formValidations_dropdown_item__uWKE2`,
	"profile_arrrow_dwn": `formValidations_profile_arrrow_dwn__hQlWp`,
	"dateinputbox1": `formValidations_dateinputbox1__0B2A-`,
	"messageminwidth": `formValidations_messageminwidth__C+uHx`,
	"sectionright": `formValidations_sectionright__kETD4`,
	"exer_modal_contain": `formValidations_exer_modal_contain__n48g5`,
	"modal-dialog": `formValidations_modal-dialog__SSaw5`,
	"addheading": `formValidations_addheading__z7Ps1`,
	"inputbox1": `formValidations_inputbox1__OWmRi`,
	"dateinputbox": `formValidations_dateinputbox__okDOR`,
	"labeltext": `formValidations_labeltext__6vPe7`,
	"eyeicon": `formValidations_eyeicon__ugyzc`,
	"dashboardcont2": `formValidations_dashboardcont2__zoJAt`
};
export default ___CSS_LOADER_EXPORT___;
